// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"650413ac","455":"c5df0a01","977":"4400e451"}[chunkId] + ".chunk.js";
};